import * as React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Container } from "../../Styles/styles";
import {
  Box,
  Button,
  Checkbox,
  FormLabel,
  TextField,
  Typography,
} from "@mui/material";
import { API } from "../../Services/Api";
import { setgid } from "process";
import { Loader } from "../../Components/Loader";
import { Link, useNavigate } from "react-router-dom";
import { app_base_url } from "../../Utils/Urls";
import { useEntidade } from "../../Hooks/EntidadeHook";
import { Tipos } from "../../Model/Tipo";
import { Empresa, useUsuario } from "../../Hooks/UsuarioHook";
import EmpresaCard from "../../Components/Home/CardEmpresas";
import { useEmpresa } from "../../Storage/empresa";
import { Filtro } from "../../Utils/filtro";
import { useUsuarioPrefeitura } from "../../Hooks/UsuarioPrefeituraHook";

interface Configuracao {
  ID: number;
  PORTAL_FOPAG: "S" | "N";
  FOPAG_DIVIDA: "S" | "N";
  DATA_ATUALIZACAO: string;
}
export function Home() {
  const [data, setData] = React.useState({} as Configuracao);
  const [loading, setLoading] = React.useState(false);
  const { entidade } = useEntidade();
  const { usuarioCompleto } = useUsuario();
  const { usuarioPrefeitura } = useUsuarioPrefeitura();
  const [editModal, setEditModal] = React.useState(false);
  const { empresa } = useEmpresa();
  const [pesquisa, setPesquisa] = React.useState("");
  const navigate = useNavigate();
  function renderEmpresas() {
    
    let help: Empresa[] = [];
    if (usuarioCompleto.empresas) {
      help = [...usuarioCompleto.empresas];
    }
    if (empresa.length > 0) {
      help = [...empresa];
    }

    help = help.filter((item) => Filtro(pesquisa, item));
    // if (usuarioCompleto.empresas && usuarioCompleto.empresas.length > 0) {
    //   return usuarioCompleto.empresas.map((i) => <EmpresaCard empresa={i} />);
    // }

    return help.map((i) => <EmpresaCard empresa={i} />);
  }

  return (
    <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  }}
>
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      width: "100%",
      maxWidth: 800,
      px: 2,
      mb: 2,
    }}
  >
    <TextField
      fullWidth
      label="Pesquisar empresa"
      variant="standard"
      value={pesquisa}
      onChange={(ev) => setPesquisa(ev.target.value)}
    />
  </Box>

  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: 2,
    }}
  >
    {renderEmpresas()}
  </Box>
</div>

  );
}
